import React from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
} from "react-bootstrap";

import {
  CalendarDays,
  Clock3,
} from "lucide-react";

export default function BlogHero({ blog }) {
  return (
    <section className="blog-hero-section">
      <Container>
        {/* Breadcrumb */}
        <Breadcrumb className="custom-breadcrumb">
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>

          <Breadcrumb.Item href="/blogs">
            Blog
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
            {blog.title}
          </Breadcrumb.Item>
        </Breadcrumb>

        {/* Title */}
        <Row>
          <Col lg={10}>
            <h1 className="blog-title">
              {blog.title}
            </h1>
          </Col>
        </Row>

        {/* Meta Info */}
        <Row className="meta-wrapper">
          {/* Author */}
          <Col lg={4} md={4} sm={12}>
            <div className="meta-box">
              <span className="meta-label">
                Author
              </span>

              <div className="meta-content">
                <img
                  src="https://i.pravatar.cc/80"
                  alt="author"
                  className="author-image"
                />

                <span className="meta-text">
                  {blog.author}
                </span>
              </div>
            </div>
          </Col>

          {/* Date */}
          <Col lg={4} md={4} sm={12}>
            <div className="meta-box">
              <span className="meta-label">
                Date
              </span>

              <div className="meta-content">
                <CalendarDays
                  size={30}
                  strokeWidth={2}
                />

                <span className="meta-text">
                  {blog.date}
                </span>
              </div>
            </div>
          </Col>

          {/* Read Time */}
          <Col lg={4} md={4} sm={12}>
            <div className="meta-box">
              <span className="meta-label">
                Read time
              </span>

              <div className="meta-content">
                <Clock3
                  size={30}
                  strokeWidth={2}
                />

                <span className="meta-text">
                  {blog.readTime}
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}